import { axiosAuthAPI } from '@/plugins/axios';
import type { PersonalAccessToken } from '../types';

export const loadPersonalAccessTokenList = () => axiosAuthAPI.get('/personal-tokens');
export const createPersonalAccessToken = (payload: PersonalAccessToken) => axiosAuthAPI.post('/personal-tokens', payload);
export const revokePersonalAccessToken = (payload: { token: string }) => axiosAuthAPI.post('/personal-tokens/revoke', payload);
